import { render, staticRenderFns } from "./UpcomingLive.vue?vue&type=template&id=059c12df&"
import script from "./UpcomingLive.vue?vue&type=script&lang=js&"
export * from "./UpcomingLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports